import { formatDateTime } from "../DateFormats";
import * as DTP from "./DateTimePickerStyles";
import { monthNames } from "./utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const HourView = _ref => {
  let {
    year,
    month,
    day,
    datesObject,
    onSelectHour
  } = _ref;
  const dayData = datesObject;
  const timeOptions = dayData.dates.map(m => ({
    value: m,
    label: formatDateTime(m)
  }));
  if (timeOptions.length <= 24) {
    return null;
  }
  return /*#__PURE__*/_jsxs(DTP.Grid, {
    children: [/*#__PURE__*/_jsx(DTP.GridHeading, {
      children: "Select an hour on ".concat(day, " ").concat(monthNames[month + 1], " ").concat(year)
    }), /*#__PURE__*/_jsx(DTP.GridBody, {
      children: dayData.index.map(hour => /*#__PURE__*/_jsxs(DTP.DateButton, {
        onClick: () => onSelectHour(hour),
        children: [/*#__PURE__*/_jsxs("span", {
          children: [hour, " : 00 - ", hour + 1, " : 00"]
        }), " ", /*#__PURE__*/_jsxs("span", {
          children: ["(", dayData[hour].length, " options)"]
        })]
      }, hour))
    })]
  });
};